import React from 'react';
const points = [{
  icon: '🔧',
  title: 'Visual diagnostic resources',
  text: 'Find the right diesel fault-finding reference when you need it.'
}, {
  icon: '📋',
  title: 'Structured diagnostic paths',
  text: 'Move from symptom or trouble code to possible cause with a clearer process.'
}, {
  icon: '🚛',
  title: '6 diagnostic areas',
  text: 'Workflow, fuel, turbo, electronics, emissions and advanced diesel faults.'
}, {
  icon: '🔄',
  title: 'Ready to use again and again',
  text: 'Return to the tools whenever a new diesel problem appears.'
}];
export function ChangeSection() {
  return <section className="border-y border-brand-line bg-white px-4 py-5" data-id="element-28" data-mp="2y1k21q5jnru">
      <div className="mx-auto max-w-3xl text-center" data-id="element-29" data-mp="7wl57zwx8vj5">
        <h2 className="font-display text-[19px] leading-tight sm:text-2xl" data-id="element-30" data-mp="7xe5qj5aeosu">
          This isn&apos;t just another diesel ebook
        </h2>
        <p className="mb-3 font-cond text-[15px] font-bold uppercase tracking-wide text-brand-carbon sm:text-xl" data-id="element-31" data-mp="22am24f8wv8gl">
          It&apos;s a <span className="bg-brand-yellow px-1" data-id="element-32" data-mp="3dcmb4m8dg1r1">ready-to-use diagnostic system</span>.
        </p>
        <ul className="grid gap-2 text-left sm:grid-cols-2" data-id="element-33" data-mp="39c2ctfc2as3b">
          {points.map(point => <li key={point.title} className="flex h-full gap-2 rounded-lg border border-brand-line bg-brand-paper p-3" data-id="element-34" data-mp="3n2nx98h5za3b">
              <span aria-hidden="true" className="text-lg leading-none" data-id="element-35" data-mp="3i3kp3f5w0nr4">
                {point.icon}
              </span>
              <div data-id="element-36" data-mp="2uf1j56ab8n27">
                <p className="font-cond text-[13px] font-bold uppercase leading-tight text-brand-carbon sm:text-base" data-id="element-37" data-mp="2uejmi8jqk6tr">
                  {point.title}
                </p>
                <p className="text-[12px] font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-38" data-mp="34d8wzg9ayozz">
                  {point.text}
                </p>
              </div>
            </li>)}
        </ul>
        <p className="mt-2 font-cond text-[13px] font-bold uppercase tracking-wide text-brand-carbon sm:text-base" data-id="element-39" data-mp="jl5rr7ov6f62">
          Less searching. Less guessing. More structure.
        </p>
      </div>
    </section>;
}